import { Pipe, PipeTransform } from '@angular/core';
import {
    DataSchemaFriendlyNames
} from '@app/views/admin/application-settings/models/data-schema-name.model';

@Pipe({
    name: 'ngcDataSchemaFriendlyName'
})
export class DataSchemaFriendlyNamePipe implements PipeTransform {

    transform(schemaName: string): any {
        if (schemaName) {
            return DataSchemaFriendlyNames[schemaName] || schemaName.replace('_', ' ');
        }

        return '';
    }

}
